  <template>
  <v-container class="pa-5" style="max-width: 700px; margin: auto">
    <!-- Card principal -->
    <Loading v-if="isLoading" :isLoading="isLoading" />

    <v-card
      v-else
      elevation="23"
      class="pa-4 mx-auto"
      max-width="700px"
      rounded="xl"
    >
      <!-- Data del recibo principal -->
      <div v-if="this.datosRecibo">
        <v-row class="text-spacing">
          <v-col cols="5">
            <h5 class="font-weight-bold text-blue mb-1">
              Datos del recibo a pagar
            </h5>
          </v-col>
          <v-col cols="7" class="text-right">
            <p class="mb-1 interline-spacing">
              <!--<strong>Ramo:</strong> {{ datosGenerales.pRamo }}-->
            </p>
          </v-col>
          <v-col cols="12" class="interline-spacing tight-line-spacing">
            <p class="mb-4">
              <strong>Contratante:</strong> {{ datosRecibo.pContratante }}
            </p>
          </v-col>
        </v-row>

        <!-- Datos detallados del recibo -->
        <v-row class="tight-line-spacing">
          <v-col cols="12">
            <p><strong>Póliza:</strong> {{ datosGenerales.pPoliza }}</p>
            <p><strong>Número de recibo:</strong> {{ datosRecibo.pRecibo }}</p>
            <p>
              <strong>Estatus:</strong>
              <span class="text-success">{{ datosRecibo.pEstatus }}</span>
            </p>
            <p>
              <strong>Importe a pagar:</strong>
              <span class="text-bold">
                ${{
                  Number(datosRecibo.pImporteRecibo).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </p>
            <p><strong>Moneda:</strong> {{ datosRecibo.pMoneda }}</p>
            <p>
              <strong>Fecha de inicio de vigencia del recibo:</strong>
              {{ datosRecibo.pFechaVencimiento }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
      </div>

      <!-- Sección de Endosos y Recibos a mostrar -->
      <div v-if="!datosRecibo && recibosAMostrar.length">
        <v-row>
          <v-col>
            <h5 cols="8" class="font-weight-bold text-blue mb-2">Endosos</h5>
          </v-col>
          <!-- <v-col v-if="!this.datosRecibo" cols="4" class="text-right">
            <p class="mb-1 interline-spacing">
              <strong>Ramo:</strong> {{ datosGenerales.pRamo }}
            </p>
          </v-col>-->
        </v-row>
        <v-col cols="12">
          <p>
            Selecciona el endoso a pagar. Si tienes dudas consulta los detalles
            en tu póliza
          </p>
        </v-col>

        <v-row>
          <v-col cols="12" class="d-flex flex-column align-center">
            <v-text-field
              v-model="searchQuery"
              outlined
              dense
              placeholder="Escribe tu número de Endoso"
              class="custom-input"
              hide-details
            ></v-text-field>
            <v-btn elevation="2" class="small-btnEndoso" @click="buscarEndoso">
              Buscar
            </v-btn>
          </v-col>
        </v-row>

        <!-- Listado de paneles expansibles (sin agrupar) -->
        <div cols="12" class="mt-2">
          <v-expansion-panels
            v-model="activePanels"
            multiple
            class="full-width"
          >
            <v-expansion-panel
              v-for="(item, index) in recibosPaginados"
              :key="item.pRecibo"
              class="custom-expansion-panel"
            >
              <v-expansion-panel-header>
                <div class="d-flex align-center w-100">
                  <!-- Checkbox del recibo/endoso -->
                  <label class="custom-checkbox">
                    <input
                      type="checkbox"
                      :value="item"
                      v-model="selectedEndosos"
                      @change="imprimirSeleccion(item, $event.target.checked)"
                      :checked="
                        selectedEndosos.length &&
                        selectedEndosos[0].pRecibo === item.pRecibo
                      "
                    />
                    <span class="checkmark"></span>
                  </label>

                  <!-- Información resumida de este “item” -->
                  <div class="d-flex justify-space-between w-100 text-endoso">
                    <div>
                      <p class="mb-0">
                        <strong class="text-endoso">Endoso:</strong>
                        {{ item.pEndoso }}
                      </p>
                      <p
                        class="mb-0"
                        :class="{
                          'text-selected': selectedEndosos.includes(item),
                          'text-success': !selectedEndosos.includes(item),
                        }"
                      >
                        <strong class="text-endoso">Importe:</strong>
                        ${{
                          Number(item.pImporteRecibo).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="custom-expansion-content">
                <!-- Detalles completos de este “item” -->
                <p>
                  Contratante:
                  <span class="value-text">{{ item.pContratante }}</span>
                </p>
                <p>
                  Póliza:
                  <span class="value-text">{{ datosGenerales.pPoliza }}</span>
                </p>
                <p>
                  Endoso:
                  <span class="value-text">{{ item.pEndoso }}</span>
                </p>
                <!--<p>
                  Inciso:
                  <span class="value-text">{{ item.pNumInciso }}</span>
                </p>-->
                <p>
                  Número de recibo:
                  <span class="value-text">{{ item.pRecibo }}</span>
                </p>
                <p>
                  Estatus:
                  <span class="value-text">{{ item.pEstatus }}</span>
                </p>
                <p>
                  Fecha de inicio de vigencia:
                  <span class="value-text">{{ item.pFechaVencimiento }}</span>
                </p>
                <p>
                  Moneda:
                  <span class="value-text">{{ item.pMoneda }}</span>
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- Navegación de páginas -->
        <v-row class="text-center mt-3 align-center">
          <v-col class="d-flex justify-center align-center" cols="12">
            <p class="mb-0 mr-5 text-paginador">
              Da clic en la flechita para ver más resultados.
            </p>
            <v-btn icon @click="paginaAnterior" :disabled="currentPage === 1">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span class="mx-2 num-paginador"
              >{{ currentPage }} / {{ totalPages }}</span
            >
            <v-btn
              icon
              @click="paginaSiguiente"
              :disabled="currentPage === totalPages"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div>
        <v-checkbox
          v-model="accepted"
          :rules="[(v) => !!v || 'Debes aceptar los términos']"
          class="terms-checkbox-custom"
          dense
          hide-details
        >
          <template #label>
            <span class="terms-text">
              Acepto las condiciones del servicio y la
            </span>
          </template>
        </v-checkbox>
        <span class="terms-text">
          <a
                href="https://latinoseguros.com.mx/sitio2021/aviso-de-privacidad/"
                target="_blank"
                class="terms-link">política de privacidad </a>.
        </span> 
      </div>

      <div class="botones-pago-cancelar">
        <!-- Botón “Pagar” -->
        <v-btn
          :disabled="!accepted"
          class="btn-azul-cielo"
          @click="abrirModalFormaDePago"
        >
          Pagar
        </v-btn>
        <v-btn v-if="canShowEnvBtn" class="env-btn" @click="consultaFormaPago">
          Enviar liga
        </v-btn>

        <!-- Botón “Cancelar” -->
        <v-btn
          v-if="ocultarBtnCacelar"
          elevation="2"
          class="cancel-btn small-btn"
          @click="cancelarPago"
        >
          Volver
        </v-btn>
      </div>
    </v-card>

    <ModalFormaDePago ref="paymentModal" />
    <ModalInfo v-model="showInfo" @input="onInfoClose">
      <template #header>{{ infoHeader }}</template>
      <template #default>
        <p>{{ infoBody }}</p>
      </template>
      <template #footer>
        <v-btn color="primary" @click="showInfo = false">Cerrar</v-btn>
      </template>
    </ModalInfo>
    <ModalEstadoTransaccion ref="transactionModal" />
  </v-container>
</template>


  <script>
import ModalFormaDePago from "./ModalFormaDePago.vue";
import ModalInfo from "./ModalInfo.vue";
import ModalEstadoTransaccion from "./ModalEstadoTransaccion.vue";
import { allowedProfiles } from "./allowedUsers.js";
import { mapGetters } from "vuex";
import Loading from "../isep/Tools/loading.vue";
import axios from "axios";
import { getBaseUrl } from "../../store/actions/ModuloActions";

export default {
  data() {
    return {
      datosGenerales: null,
      datosRecibo: null,
      activePanels: [],
      selectedEndosos: [],
      datosEndosos: null,
      filteredEndosos: [],
      searchQuery: "",
      bancosData: [],
      currentPage: 1,
      itemsPerPage: 3,
      isLoading: false,
      ocultarBtnCacelar: true,
      disabled: false,
      disableButtons: true,
      showInfo: false,
      infoHeader: "",
      infoBody: "",
      recibosAMostrar: [],

      checkoutSessionId: "",
      urlToku: "",
      accepted: false,
    };
  },
  watch: {
    // Observa el array selectedEndosos
    selectedEndosos(newVal) {
      // Actualiza el estado del botón dinámicamente
      if (this.datosRecibo) {
        this.disableButtons = false; // Siempre habilitado si datosRecibo tiene valor
      } else {
        this.disableButtons = !(newVal && newVal.length > 0); // Desactivado si no hay endosos seleccionados
      }
    },
    datosRecibo(newVal) {
      // Si datosRecibo tiene datos, habilita los botones
      if (newVal) {
        this.disableButtons = false;
      } else {
        // Si datosRecibo está vacío, verifica selectedEndosos
        this.disableButtons = !(
          this.selectedEndosos && this.selectedEndosos.length > 0
        );
      }
    },
  },

  computed: {
    ...mapGetters(["getPolizaData"]),

    paginatedEndosos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;
      return this.filteredEndosos.slice(start, end);
    },

    paginatedGroupedEndosos() {
      if (
        !this.groupedEndosos ||
        Object.keys(this.groupedEndosos).length === 0
      ) {
        return {};
      }

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;

      // Convertir los objetos agrupados en un array para paginarlos
      const groupedArray = Object.entries(this.groupedEndosos);

      // Filtrar los elementos de la página actual
      const paginatedArray = groupedArray.slice(start, end);

      // Convertir de nuevo a un objeto agrupado
      return Object.fromEntries(paginatedArray);
    },
    totalPages() {
      return Math.ceil(this.recibosAMostrar.length / this.itemsPerPage);
    },

    selectedEndosos() {
      return this.$store.getters.getSelectedEndosos || [];
    },
    groupedEndosos() {
      if (!this.filteredEndosos || this.filteredEndosos.length === 0) {
        return {};
      }

      // Agrupar recibos por `pEndoso`
      const grouped = this.filteredEndosos.reduce((groups, recibo) => {
        if (!groups[recibo.pEndoso]) {
          groups[recibo.pEndoso] = [];
        }
        groups[recibo.pEndoso].push(recibo);
        return groups;
      }, {});

      const result = {};

      // Separar recibos únicos y grupos
      Object.keys(grouped).forEach((key) => {
        if (grouped[key].length > 1) {
          result[key] = grouped[key]; // Grupos con múltiples recibos
        } else {
          const reciboUnico = grouped[key][0];
          result[reciboUnico.pRecibo] = [reciboUnico]; // Recibo único como un grupo separado
        }
      });

      return result;
    },
    recibosPaginados() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.recibosAMostrar.slice(start, start + this.itemsPerPage);
    },

    currentProfileId() {
      return localStorage.getItem("profileId") || "0";
    },

    canShowEnvBtn() {
      return (
        this.currentProfileId !== "0" &&
        allowedProfiles.includes(this.currentProfileId)
      );
    },
  },

  mounted() {
    this.$store.dispatch("guardaDatosPolizaProvenientesUrl", []);

    const token = localStorage.getItem("token");
    if (token) {
      //console.log("Token ya existe en localStorage:", token);
    } else {
      this.realizarLogin();
    }

    const id = this.$route.query.p;
    const filial = this.$route.query.f || null;
    const i = this.$route.query.i; // Si lo necesitas
    const u = this.$route.query.u; // Si lo necesitas

    if (id || filial || i || u) {
      this.ocultarBtnCacelar = false;

      this.isLoading = true;
      const checkProfileId = setInterval(() => {
        const profileId = localStorage.getItem("profileId");
        if (profileId) {
          clearInterval(checkProfileId); // Detener el intervalo una vez que se encuentra el usuario
          this.buscarPoliza(id, filial, i, u).finally(() => {
            this.isLoading = false; // Desactivar el loading al finalizar
          });
        }
      }, 100); // Verificar cada 100ms
    } else if (this.getPolizaData && this.getPolizaData.pDatosGenerales) {
      this.consultaBancos();
      this.datosGenerales = this.getPolizaData.pDatosGenerales;
      //this.datosRecibo = this.getPolizaData.pDatosRecibo;
      //this.datosEndosos = this.getPolizaData.pEndosos;
      this.procesarRecibos({
        pDatosRecibo: this.getPolizaData.pDatosRecibo,
        pEndosos: this.getPolizaData.pEndosos,
      });

      if (this.datosEndosos && this.datosEndosos.length > 0) {
        this.filteredEndosos = [...this.datosEndosos];
      } else {
        console.log(
          "datosEndosos está vacío o es null, no se asignará a filteredEndosos."
        );
      }
      if (
        (this.datosEndosos === null || this.datosEndosos.length <= 0) &&
        (this.datosRecibo === null || this.datosRecibo.length <= 0)
      ) {
        this.infoHeader = "Atención";
        this.infoBody = "No se encontró ningún recibo por pagar.";
        this.showInfo = true;
      }
      const totalImportes = this.sumarImportes();
    } else {
      this.$router.push("/pago-en-linea/paso-1"); // Redirigir si no hay datos
    }
  },

  components: {
    ModalFormaDePago,
    ModalEstadoTransaccion,
    Loading,
    ModalInfo,
  },
  methods: {
    /* enviarURLPago() {
      this.$refs.transactionModal.openModal({
      
        transactionDetails: {
          contratante: .pContratante,
          poliza: "test",
          nuRecibo: "test",
          estatus: "bien",
          importePagar: "test",
          moneda: "2",
          fechaVencimiento: "1",
        },
        showActions: true,
      });
    },*/

    enviarURLPago() {
      const detalleFuente =
        Array.isArray(this.selectedEndosos) && this.selectedEndosos.length > 0
          ? this.selectedEndosos[0]
          : this.datosRecibo;

      const detalles = {
        contratante: detalleFuente.pContratante,
        poliza: this.datosGenerales.pPoliza,
        nuRecibo: detalleFuente.pRecibo,
        estatus: detalleFuente.pEstatus,
        importePagar: detalleFuente.pImporteRecibo,
        moneda: detalleFuente.pMoneda,
        fechaVencimiento: detalleFuente.pFechaVencimiento,
      };

      this.$refs.transactionModal.openModal({
        transactionDetails: detalles,
        showActions: true,
      });
    },

    procesarRecibos(rawData) {
      // 1) Guardar directamente en propiedades
      this.datosRecibo = rawData.pDatosRecibo;
      this.datosEndosos = rawData.pEndosos;

      // 2) Construir el arreglo final 'recibosAMostrar' según las reglas
      // (a) Si pDatosRecibo viene no nulo:
      if (this.datosRecibo) {
        // Si es un ARRAY y tiene al menos 1, tomar el primer elemento
        if (Array.isArray(this.datosRecibo) && this.datosRecibo.length > 0) {
          this.recibosAMostrar = [this.datosRecibo[0]];
        }
        // Si es un OBJETO (no array), envolverlo en arreglo
        else if (
          typeof this.datosRecibo === "object" &&
          !Array.isArray(this.datosRecibo)
        ) {
          this.recibosAMostrar = [this.datosRecibo];
        } else {
          // Por seguridad, si vienen otros tipos, vaciamos
          this.recibosAMostrar = [];
        }
      }
      // (b) Si no hay datos en pDatosRecibo y sí hay pEndosos:
      else if (
        !this.datosRecibo &&
        Array.isArray(this.datosEndosos) &&
        this.datosEndosos.length > 0
      ) {
        // Mostrar TODOS los endosos
        this.recibosAMostrar = [...this.datosEndosos];
      }
      // (c) Si ni datosRecibo ni endosos (o vienen vacíos), limpiar
      else {
        this.recibosAMostrar = [];
      }
    },
    ordenarPorFecha(recibos) {
      return [...recibos].sort(
        (a, b) => new Date(a.pFechaVencimiento) - new Date(b.pFechaVencimiento)
      );
    },

    deshabilitarRecibo(index, recibosOrdenados) {
      // Verifica si hay recibos anteriores sin seleccionar
      for (let i = 0; i < index; i++) {
        if (
          !this.selectedEndosos.some(
            (e) => e.pRecibo === recibosOrdenados[i].pRecibo
          )
        ) {
          return true; // Recibo no seleccionable
        }
      }
      return false; // Recibo seleccionable
    },

    verificarSeleccion(index, recibosOrdenados, event) {
      const recibo = recibosOrdenados[index];

      if (this.deshabilitarRecibo(index, recibosOrdenados)) {
        // Mostrar alerta
        this.$swal(
          "Debes seleccionar los recibos con fechas más antiguas antes de continuar.",
          "",
          "warning"
        );

        // Desmarcar el checkbox
        event.target.checked = false;

        // Eliminar el recibo del array si fue agregado automáticamente por el v-model
        this.selectedEndosos = this.selectedEndosos.filter(
          (item) => item.pRecibo !== recibo.pRecibo
        );
      } else {
        // Si es válido, actualizar el array selectedEndosos
        if (event.target.checked) {
          // Agregar el recibo si no está ya seleccionado
          if (
            !this.selectedEndosos.some(
              (item) => item.pRecibo === recibo.pRecibo
            )
          ) {
            this.selectedEndosos.push(recibo);
          }
        } else {
          // Eliminar el recibo si se deselecciona
          this.selectedEndosos = this.selectedEndosos.filter(
            (item) => item.pRecibo !== recibo.pRecibo
          );
        }
      }
    },

    /* imprimirSeleccion(endoso, isChecked) {
        if (isChecked) {
          // Agregar endoso si no está ya seleccionado
          if (
            !this.selectedEndosos.some(
              (e) =>
                e.pEndoso === endoso.pEndoso &&
                e.pFechaVencimiento === endoso.pFechaVencimiento
            )
          ) {
            this.selectedEndosos.push(endoso);
          }
        } else {
          // Eliminar endoso del array si se deselecciona
          this.selectedEndosos = this.selectedEndosos.filter(
            (e) =>
              e.pEndoso !== endoso.pEndoso ||
              e.pFechaVencimiento !== endoso.pFechaVencimiento
          );
        }

        // Actualizar el estado en Vuex
        this.$store.dispatch("toggleSelectedEndoso", this.selectedEndosos);

        console.log("Endosos seleccionados (store):", this.selectedEndosos);
      },*/
    imprimirSeleccion(endoso, isChecked) {
      if (isChecked) {
        // Al marcar, dejamos sólo este endoso en el array
        this.selectedEndosos = [endoso];
      } else {
        // Al desmarcar, lo eliminamos dejando el array vacío
        this.selectedEndosos = [];
      }

      // Actualiza el estado en Vuex (si lo necesitas)
      this.$store.dispatch("toggleSelectedEndoso", this.selectedEndosos);
    },

    async buscarPoliza(id, filial, i, u) {
      //this.isLoading = true;
      // Dividir el id en caso de que contenga "/"
      this.showInfo = false;
      let pEsFilial = false;
      if (filial > 0) {
        pEsFilial = true;
      }

      const payload = {
        metodo: "BUSCAPOLIZA",
        data: {
          pPoliza: id,
          pNumFilial: filial,
          pEsFilial: pEsFilial,
          pIdUsuario: u > 0 ? u : localStorage.getItem("profileId"),
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response && response.data) {
          this.$store.dispatch(
            "guardaDatosPolizaProvenientesUrl",
            response.data
          );
          this.datosGenerales = response.data.pDatosGenerales;
          this.datosRecibo = response.data.pDatosRecibo;

          this.datosEndosos = response.data.pEndosos;
          this.procesarRecibos({
            pDatosRecibo: response.data.pDatosRecibo,
            pEndosos: response.data.pEndosos,
          });

          // Validación para datosEndosos
          if (this.datosEndosos && this.datosEndosos.length > 0) {
            this.filteredEndosos = [...this.datosEndosos];
          } else {
            console.log(
              "datosEndosos está vacío o es null, no se asignará a filteredEndosos."
            );
          }

          if (
            (this.datosEndosos === null || this.datosEndosos.length <= 0) &&
            (this.datosRecibo === null || this.datosRecibo.length <= 0)
          ) {
            this.infoHeader = "Atención";
            this.infoBody = "No se encontró ningún recibo por pagar.";
            this.showInfo = true;
          }

          this.consultaBancos();
        } else {
          this.$swal(
            response.errorMessage,
            response.errorMessage || "No se encontraron datos de la póliza.",
            "error"
          );
        }
      } catch (error) {
        this.$swal({
          title: "No se encontraron datos de la póliza.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            content: "custom-swal-text",
          },
        });
      } finally {
        this.isLoading = false;
      }
    },
    async consultaFormaPago() {
      this.isLoading = true;

      // 1) Calcular importe de endosos seleccionados
      let importeEndosos = 0;
      if (Array.isArray(this.selectedEndosos)) {
        importeEndosos = this.selectedEndosos.reduce(
          (total, endoso) => total + (endoso.pImporteRecibo || 0),
          0
        );
      } else if (
        this.selectedEndosos &&
        typeof this.selectedEndosos === "object"
      ) {
        importeEndosos = this.selectedEndosos.pImporteRecibo || 0;
      }

      // 2) Añadir importe del recibo principal
      const importeRecibo = this.datosRecibo?.pImporteRecibo || 0;

      // 3) Total
      const importeTotal = importeEndosos + importeRecibo;

      // Verificar si hay datos en la store
      if (this.$store.state.datosPolizaProvenientesUrl) {
        const datosPoliza = this.$store.state.datosPolizaProvenientesUrl;

        this.datosGenerales = datosPoliza.pDatosGenerales;
        this.datosRecibo = datosPoliza.pDatosRecibo;
        this.datosEndosos = datosPoliza.pEndosos;
      }

      if (this.getPolizaData) {
        this.datosGenerales = this.getPolizaData.pDatosGenerales;
        this.datosRecibo = this.getPolizaData.pDatosRecibo;
        this.datosEndosos = this.getPolizaData.pEndosos;
      }

      const referenciaElegida =
        this.datosRecibo && this.datosRecibo.pReferencia
          ? this.datosRecibo.pReferencia
          : Array.isArray(this.selectedEndosos) && this.selectedEndosos.length
          ? this.selectedEndosos[0].pReferencia
          : "";

      console.log("refencia para envio liga de pago:")
      console.log(referenciaElegida);

      // Construcción del payload
      const payload = {
        metodo: "CONSULTARFORMAPAGO",
        data: {
          montoTotal: importeTotal,
          idAplicacon: localStorage.getItem("applicationNumber"),
          //idBanco: this.idBanco,
          idBanco: 4,
          referencia: referenciaElegida,
          usuario: localStorage.getItem("profileId"),
          pDatosGenerales: {
            pRamoLetra: this.datosGenerales?.pRamoLetra || "",
            pRamo: this.datosGenerales?.pRamo || "",
            pPoliza: this.datosGenerales?.pPoliza || "",
            pProducto: this.datosGenerales?.pProducto || "",
            pAgente: this.datosGenerales?.pAgente || "",
            pSistema: this.datosGenerales?.pSistema || "",
            pTipoPoliza: this.datosGenerales?.pTipoPoliza || "",
            pFormaPago: this.datosGenerales?.pFormaPago || "",
          },
          pDatosRecibo: {
            pContratante: this.datosRecibo?.pContratante || "",
            pNumFilial: this.datosRecibo?.pNumFilial || "",
            pEndoso: this.datosRecibo?.pEndoso || "",
            pNumInciso: this.datosRecibo?.pNumInciso || "",
            pRecibo: this.datosRecibo?.pRecibo || "",
            pEstatus: this.datosRecibo?.pEstatus || "",
            pImporteRecibo: this.datosRecibo?.pImporteRecibo || 0,
            pMoneda: this.datosRecibo?.pMoneda || "",
            pFechaVencimiento: this.datosRecibo?.pFechaVencimiento || "",
            pReferencia: this.datosRecibo?.pReferencia || "",
            pIdClienteCU: this.datosRecibo?.pIdClienteCU || "",
            pRamoDescripcion: this.datosRecibo?.pRamoDescripcion || "",
          },
          pEndosos: this.datosEndosos || [],
        },
      };

      try {
        const { data } = await this.$store.dispatch("metodoPost", payload);
        if (data.id && data.url) {
          // Guardas la sesión
          this.checkoutSessionId = data.id;
          this.urlToku = data.url;
          localStorage.setItem("tokuUrl", this.urlToku);
          localStorage.setItem("checkoutSessionId", this.checkoutSessionId);

          this.enviarURLPago();
        } else {
          throw new Error("No se obtuvo id/url de Toku");
        }
      } catch (err) {
        this.$swal(
          "Error",
          err.message || "Falló la consulta de pago",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    onInfoClose(isOpen) {
      if (!isOpen) {
        this.$router.push("/pago-en-linea/paso-1");
      }
    },
    async realizarLogin() {
      // Usuario y contraseña hardcodeados
      const usuarioHardcoded = {
        userName: "900566",
        password: "566",
      };

      try {
        const url = `${getBaseUrl()}security/api/Login`;
        const response = await axios.post(url, usuarioHardcoded, {
          headers: {
            "Content-Type": "application/json",
            XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          },
        });

        if (response.status === 200 && response.data.flag) {
          // Guardar el token y otros datos en localStorage
          const token = response.data.data.tokenId;
          localStorage.setItem("token", token);
          localStorage.setItem("profileId", response.data.data.profileId);
        } else {
          //console.error("Error en el login:", response.data.errorMessage);
        }
      } catch (error) {
        //console.error("Error en la solicitud de login:", error);
      }
    },
    isSelected(endoso) {
      return this.$store.getters.getSelectedEndosos.some(
        (e) =>
          e.pEndoso === endoso.pEndoso &&
          e.pFechaVencimiento === endoso.pFechaVencimiento
      );
    },
    escucharDatosPoliza() {
      // Escucha el evento emitido desde PasoNumeroPoliza
      EventBus.$on("datosPoliza", (polizaData) => {
        if (polizaData) {
          // Asigna los datos a las propiedades para usarlas en la vista
          this.datosGenerales = polizaData.pDatosGenerales;
          this.datosRecibo = polizaData.pDatosRecibo;
        } else {
          this.$router.push("/pago-en-linea/paso-1"); // Redirige si no hay datos
        }
      });
    },
    sumarImportes() {
      let total = 0;

      // Sumar pImporteRecibo de pDatosRecibo si existe y no es null
      if (this.getPolizaData && this.getPolizaData.pDatosRecibo) {
        total += this.getPolizaData.pDatosRecibo.pImporteRecibo || 0;
      }

      // Sumar pImporteRecibo de pEndosos si es un arreglo y no es null
      if (this.getPolizaData && Array.isArray(this.getPolizaData.pEndosos)) {
        this.getPolizaData.pEndosos.forEach((endoso) => {
          total += endoso.pImporteRecibo || 0; // Si no existe pImporteRecibo, suma 0
        });
      }

      return total;
    },

    async consultaBancos() {
      // Construcción del payload
      const payload = {
        metodo: "CONSULTARBANCOS",
        data: {
          montoTotal: 0,
          idAplicacon: 0,
          idBanco: 0,
          referencia: "string",
          usuario: localStorage.getItem("profileId"),
          pDatosGenerales: {
            pRamoLetra: this.datosGenerales?.pRamoLetra || "",
            pRamo: this.datosGenerales?.pRamo || "",
            pPoliza: this.datosGenerales?.pPoliza || "",
            pProducto: this.datosGenerales?.pProducto || "",
            pAgente: this.datosGenerales?.pAgente || "",
            pSistema: this.datosGenerales?.pSistema || "",
            pTipoPoliza: this.datosGenerales?.pTipoPoliza || "",
          },
          pDatosRecibo: {
            pContratante: this.datosRecibo?.pContratante || "",
            pNumFilial: this.datosRecibo?.pNumFilial || "",
            pEndoso: this.datosRecibo?.pEndoso || "",
            pNumInciso: this.datosRecibo?.pNumInciso || "",
            pRecibo: this.datosRecibo?.pRecibo || "",
            pEstatus: this.datosRecibo?.pEstatus || "",
            pImporteRecibo: this.datosRecibo?.pImporteRecibo || 0,
            pMoneda: this.datosRecibo?.pMoneda || "",
            pFechaVencimiento: this.datosRecibo?.pFechaVencimiento || "",
            pReferencia: this.datosRecibo?.pReferencia || "",
            pIdClienteCU: this.datosRecibo?.pIdClienteCU || "",
            pRamoDescripcion: this.datosRecibo?.pRamoDescripcion || "",
          },
          pEndosos: this.datosEndosos || [],
        },
      };

      this.isLoading = true;

      try {
        // Llamada al store para realizar la consulta
        const response = await this.$store.dispatch("metodoPost", payload);

        if (response && response.data) {
          this.bancosData = response.data;
        } else {
          this.$swal(
            "Error",
            "No se encontraron datos para la consulta de bancos.",
            "error"
          );
        }
      } catch (error) {
        // Manejo de errores
        this.$swal(
          "Error en la Consulta",
          "Ocurrió un error al consultar los bancos. Intente de nuevo.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    abrirModalFormaDePago() {
      // 1) Calcular importe de endosos seleccionados
      let importeEndosos = 0;
      if (Array.isArray(this.selectedEndosos)) {
        importeEndosos = this.selectedEndosos.reduce(
          (total, endoso) => total + (endoso.pImporteRecibo || 0),
          0
        );
      } else if (
        this.selectedEndosos &&
        typeof this.selectedEndosos === "object"
      ) {
        importeEndosos = this.selectedEndosos.pImporteRecibo || 0;
      }

      // 2) Añadir importe del recibo principal
      const importeRecibo = this.datosRecibo?.pImporteRecibo || 0;

      // 3) Total
      const importeTotal = importeEndosos + importeRecibo;

      const referenciaElegida =
        this.datosRecibo && this.datosRecibo.pReferencia
          ? this.datosRecibo.pReferencia
          : Array.isArray(this.selectedEndosos) && this.selectedEndosos.length
          ? this.selectedEndosos[0].pReferencia
          : "";

      console.log("referencia elegida:");
      console.log(referenciaElegida);

      // 4) Pasar sólo el importe al modal (sin datos de banco)
      this.$refs.paymentModal.setBancoData({
        importePagar: importeTotal, 
        referenciaPago: referenciaElegida
      });
      console.log("abrir modal antes")

      // 5) Abrir el modal
      this.$refs.paymentModal.openModal();
    },

    buscarEndoso() {
      const termino = this.searchQuery.trim();

      if (termino === "") {
        // Si no hay búsqueda, restauramos TODO en recibosAMostrar
        this.recibosAMostrar = Array.isArray(this.datosEndosos)
          ? [...this.datosEndosos]
          : [];
      } else {
        // Filtramos y guardamos el resultado en recibosAMostrar
        this.recibosAMostrar = this.datosEndosos.filter((endoso) =>
          // Si pEndoso es número, conviene convertirlo a string:
          String(endoso.pEndoso).includes(termino)
        );
      }

      // Si tienes paginación, es buena idea resetear al inicio (página 1):
      this.currentPage = 1;
    },

    cancelarPago() {
      const cobranza = localStorage.getItem("cobranza");

      if (cobranza === "0") {
        // this.$router.push("/pago-en-linea/paso-1");
        window.location.reload()
      } else {
        const profileId = localStorage.getItem("profileId") || "0";
        const applicationNumber =
          localStorage.getItem("applicationNumber") || "0";
        this.$router.push(
          `/pago-en-linea/paso-1?u=${encodeURIComponent(
            profileId
          )}&a=${encodeURIComponent(applicationNumber)}`
        );
      }
    },

    paginaAnterior() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    paginaSiguiente() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
  },
};
</script>


  <style scoped>
.v-card {
  padding: 50px 60px 50px 60px; /* Superior, Derecho, Inferior, Izquierdo */
  border-radius: 30px;
}
.text-blue {
  color: #003366;
}

.text-spacing {
  line-height: 0.1;
}

.text-right {
  text-align: right;
}

.interline-spacing {
  line-height: 0.1;
}
.custom-input {
  padding: 0;
  font-size: 16px;
  height: auto;
  border-radius: 5px;
  background-color: #fff;
  border: none;
}
.full-width {
  width: 100%;
  margin-top: 0;
}
.custom-expansion-panel {
  width: 100%; /* Alineado con el botón */
  box-shadow: none; /* Opcional: Elimina sombras adicionales */
  border: 1px solid #ddd; /* Opcional: Agrega un borde consistente */
}

.custom-input .v-input__control {
  padding: 0px 1px; /* Ajusta el padding interno */
  color: #28a745 !important;
}

.mb-1 {
  margin-bottom: 0px;
}

.tight-line-spacing p {
  line-height: 0.5;
}
.small-btnEndoso {
  padding-right: 20px;
  background-color: #17a2b8 !important;

  color: white;
  font-weight: bold;
}
.small-btn {
  width: auto;
  min-width: 120px;
}

.bank-btn {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancel-btn {
  background-color: #cc0000 !important;
  color: white;
  font-weight: bold;
}
.btn-azul-cielo {
  font-size: 1rem;
  padding: 0.75rem 1rem;
  width: 150px;
}

.cancel-btn:hover {
  background-color: #ff4d4d !important;
}

.md-radio.md-checked .md-radio-container {
  color: #28a745 !important; /* Verde */
}

.custom-expansion-content {
  line-height: 0; /* Interlineado */

  padding-left: 50px; /* Padding alrededor del contenido */
  font-size: 10px; /* Tamaño del texto */
}
.text-selected {
  color: #28a745 !important; /* Verde brillante */
}
.text-success {
  color: #003366 !important;
}

.value-text {
  font-weight: bold;
  color: #000; /* Negro para los valores */
}

.value-importe {
  font-weight: bold;
  color: #28a745; /* Verde para el importe */
}

/**************************************************/
/******************CHECKBOX************************/
/**************************************************/
.custom-checkbox {
  display: flex;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
}

/* Ocultar el checkbox nativo */
.custom-checkbox input[type="checkbox"] {
  display: none;
}

/* Estilo del círculo externo */
.custom-checkbox .checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: white;
  position: relative;
  transition: all 0.3s ease;
}

/* Cambiar color cuando está seleccionado */
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #28a745; /* Verde */
  border-color: #28a745;
}

/* Indicador interno (círculo) */
.custom-checkbox .checkmark::after {
  content: "";
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: all 0.3s ease;
}

/* Mostrar el indicador interno al seleccionar */
.custom-checkbox input[type="checkbox"]:checked + .checkmark::after {
  transform: translate(-50%, -50%) scale(1);
}

.terms-checkbox-custom {
  font-size: 0.9rem;
  line-height: 1.4;
  margin-top: 0.5rem;
}

.terms-text {
  display: inline;
  font-size: 0.9rem;
  color: #444;
  position: relative;
  top: 4px;
}

.terms-link {
  color: #1976d2;
  text-decoration: underline;
  word-break: break-word;
  font-size: inherit;
}
/**************************************************/
/******************MOVIL***************************/
/**************************************************/
/* Pantallas grandes: horizontal */
@media (min-width: 769px) {
  .d-flex.flex-column {
    flex-direction: row !important; /* Horizontal en escritorio */
    justify-content: flex-start;
    align-items: center;
  }

  .custom-input {
    width: auto; /* Ajusta automáticamente el ancho del input */
    margin-bottom: 0; /* Sin espaciado */
    margin-right: 10px; /* Espaciado entre el input y el botón */
  }

  .small-btnEndoso {
    width: auto; /* Botón ajustado automáticamente */
  }
}
.botones-pago-cancelar {
  display: flex;
  flex-direction: row; /* Alineación horizontal */
  justify-content: flex-end; /* Los coloca al final del contenedor */
  gap: 12px; /* Espacio entre “Pagar” y “Cancelar” */
  margin-top: 24px; /* Opcional: separación respecto al contenido superior */
}

/* Opcional: limitar ancho de cada botón en escritorio */
.botones-pago-cancelar .btn-azul-cielo,
.botones-pago-cancelar .cancel-btn,
.botones-pago-cancelar .env-btn {
  min-width: 120px;
}

@media (max-width: 768px) {
  .v-card {
    padding: 18px;
  }
  .d-flex.flex-column {
    flex-direction: column !important;
  }
  .custom-input {
    width: 100%;
    margin-bottom: 10px;
  }

  .text-endoso {
    font-size: 12px;
  }
  .custom-expansion-content {
    line-height: 0; /* Interlineado */

    padding-left: 0px; /* Padding alrededor del contenido */
    font-size: 9px; /* Tamaño del texto */
  }

  .small-btnEndoso {
    width: 100%; /* Botón del mismo ancho que el input */
  }
  .text-paginador {
    font-size: 10px; /* Tamaño más pequeño para móviles */
    margin-bottom: 0; /* Asegura que no haya margen extra */
    line-height: 1;
    text-align: left;
  }
  .num-paginador {
    font-size: 6px;
    white-space: nowrap;
    margin-bottom: 0;
  }
  .botones-pago-cancelar {
    display: flex;
    flex-direction: column; /* Alineación vertical */
    align-items: center; /* Centra cada botón horizontalmente */
    gap: 12px; /* Espacio entre botón y botón */
    margin-top: 20px; /* Opcional: separación respecto al contenido superior */
  }

  /* Que los botones ocupen casi todo el ancho disponible en móvil */
  .botones-pago-cancelar .btn-azul-cielo,
  .botones-pago-cancelar .cancel-btn,
  .botones-pago-cancelar .env-btn {
    width: 100%;
    max-width: 300px;
  }
  .tight-line-spacing p {
    line-height: 1.5;
  }

  .terms-checkbox-custom {
    font-size: 0.6rem;
  }

  .v-input--selection-controls__ripple {
    width: 18px !important;
    height: 18px !important;
  }

  .v-input--selection-controls__input {
    transform: scale(0.9);
  }
}
</style>
